import React, { useContext } from 'react';
import { TouchableHighlight, View } from 'react-native';
import { StyleSheet } from 'react-native';
import DyteText from './DyteText';
import UserAvatar from 'react-native-user-avatar';
import DyteClient from '@dytesdk/web-core';
import { IconPack, defaultIconPack } from '../lib/icons';
import { DyteI18n, useLanguage } from '../lib/lang';
import { SvgXml } from 'react-native-svg';
import { Peer } from '../types/dyte-client';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ParticipantWaitingCard({
  meeting,
  participant,
  iconPack = defaultIconPack,
  t,
}: {
  meeting?: DyteClient;
  participant: Peer; //DyteParticipant;
  iconPack?: IconPack;
  t?: DyteI18n;
}) {
  const { storeStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  const defaultLang = useLanguage();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  t = t ?? defaultLang;
  iconPack = iconPack ?? defaultIconPack;
  const styles = StyleSheet.create({
    participantCard: {
      paddingHorizontal: 14,
      paddingTop: 4,
      paddingBottom: 12,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    participantCardLeft: {
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    hostControlContainer: {
      backgroundColor: 'rgb(44,44,44)',
      marginLeft: -5,
      marginRight: 10,
      alignItems: 'center',
      borderRadius: 5,
      position: 'absolute',
      right: -20,
      top: 30,
      width: 150,
      height: 170,
    },
    controls: {
      padding: 10,
      justifyContent: 'space-around',
      alignItems: 'flex-start',
    },
    participantNameText: {
      marginLeft: 16,
    },
    participantCardRight: {
      flexDirection: 'row',
    },
    iconStyle: {
      height: 45,
      width: 45,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: colors.background[800],
      borderRadius: 8,
      margin: 4,
    },
  });
  const rejectRequest = async () => {
    if (
      meeting.participants.waitlisted
        .toArray()
        .filter((p) => p.id === participant.id).length > 0
    ) {
      meeting.participants.rejectWaitingRoomRequest(participant.id);
      return;
    }
    if (
      (meeting.meta.viewType === 'WEBINAR' ||
        meeting.meta.viewType === 'LIVESTREAM') &&
      participant.stageStatus === 'REQUESTED_TO_JOIN_STAGE'
    ) {
      await meeting.stage.denyAccess([participant.userId]);
      return;
    }
  };
  const acceptRequest = async () => {
    if (
      (meeting.meta.viewType === 'WEBINAR' ||
        meeting.meta.viewType === 'LIVESTREAM') &&
      participant.stageStatus === 'REQUESTED_TO_JOIN_STAGE'
    ) {
      await meeting.stage.grantAccess([participant.userId]);
      return;
    }
    if (
      meeting.participants.waitlisted
        .toArray()
        .filter((p) => p.id === participant.id)
    ) {
      meeting.participants.acceptWaitingRoomRequest(participant.id);
      return;
    }
  };
  return (
    <View style={styles.participantCard}>
      <View style={styles.participantCardLeft}>
        <UserAvatar
          size={40}
          src={participant.picture}
          name={participant.name ?? 'TT'}
          bgColor={colors.brand[300]}
        />
        <DyteText style={styles.participantNameText} size="lg">
          {participant.name}
        </DyteText>
      </View>
      <View style={styles.participantCardRight}>
        <TouchableHighlight
          underlayColor={colors.background[800]}
          onPress={rejectRequest}
          style={styles.iconStyle}
        >
          <SvgXml
            xml={iconPack.dismiss.replace('currentColor', colors.danger)}
            width={25}
            height={25}
          />
        </TouchableHighlight>
        <TouchableHighlight
          underlayColor={colors.background[800]}
          onPress={acceptRequest}
          style={styles.iconStyle}
        >
          <SvgXml
            xml={iconPack.checkmark.replace('currentColor', colors.success)}
            width={25}
            height={25}
          />
        </TouchableHighlight>
      </View>
    </View>
  );
}
